import icons from "../../../database/icone";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import axios from "axios";
import { useStateContext } from "../../../Context/ContextProvider";
import { toast } from "react-toastify";
import { HiOutlineDocument } from "react-icons/hi";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalFormationEtp from "../ModalFormationBaseEtp/ModalFormationBaseEtp";
import ModalProgrammeEtp from "../ModalProgrammeEtp/ModalProgrammeEtp";


export default function DetailModuleEtp() {

    const navigate = useNavigate();
    const location = useLocation();
    // programme pédagogique
    const [isFormVisible, setIsFormVisible] = useState(false);

    // prérequis
    const [isPrerequis, setIsPrerequis] = useState(false);

    //matériels
    const [isMateriel, setIsMateriel] = useState(false);

    //public
    const [isPublic, setIsPublic] = useState(false);

    // objectif
    const [isObjectif, setIsObjectif] = useState(false);

    // affichage modification formation de base
    const [isFormationBase, setIsFormationBase] = useState(false);
    //affichage modification programme
    const [isModifProgramme, setIsModifProgramme] = useState(false);

    //stockage des programme selectionnée
    const [selectedProgramme, setSelectedProgramme] = useState(null)

    // champs de module
    //const setPreview = useState('/default-image.jpg');
    //modification image
    const [image, setImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    // affichage veuiller séléctionné une image
    const [selectImage, setSelectImage] = useState(null);

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    //state pour stocker les données du module et gestion d'erreur et loading
    const [moduleData, setModuleData] = useState(null);

    //un state pour les objectifs
    const [objectifs, setObjectifs] = useState([]);
    //state pour ajout objectif
    const [newObjectif, setNewObjectif] = useState("");
   

    //state pour prerequis
    const [prerequis, setPrerequis] = useState([]);
    //state pour ajout prerequis
    const [newPrerequis, setNewPrerequis] = useState("");

    //un state pour les matériel(prestation)
    const [prestation, setPrestation] = useState([]);
    //state pour ajout materile(prestation)
    const [newPrestation, setNewPrestation] = useState("");

    //un state pour les cibles
    const [cible, setCible] = useState([]);
    //un state pour ajout des cibles
    const [newCible, setNewCible] = useState("");

    //un state pour les programmes
    const [programmes, setProgrammes] = useState([]);

    //un state pour le qualité
    const [qualityScore, setQualityScore] = useState(0);
    // Calculez le pourcentage avant le return
    const qualityPercentage = Math.round((qualityScore / 6) * 100);
    const clampeQualityPercentage = Math.min(qualityPercentage, 100);

    //affichage ressources
    const [isRessource, setIsRessource] = useState(null); //modal ito
    const [file, setFile] = useState([]);//upload
    const [uploadedFiles, setUploadedFiles] = useState([]);//affichage après upload

    const [isSubmitting, setIsSubmitting] = useState(false);

    //API ajout programme
    const [newProgramme, setNewProgramme] = useState({
        program_title: '',
        program_description: ''
    });

    const { token } = useStateContext();
    //récupération ID du module depuis URL
    const { id } = useParams();
    const baseURL = "https://formafusionmg.ams3.cdn.digitaloceanspaces.com/formafusionmg/";

    //tout les API get
    useEffect(() => {
        fetchModuleData();
        fetchObjectif();
        fetchPrerequis();
        fetchMateriel();
        fetchCible();
        fetchProgramme();
        fetchQualityScore();
        fetchRessource();

    }, [id]);

    if (!id) return;

    // API get formation de base
    const fetchModuleData = async () => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/edit`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            const moduleData = response.data.module;
            console.log('STATUS DU MODULE:', response.data.module.status);
            console.log("Données complètes du module :", response.data);

            const imagePath = moduleData.module_image
                ? `${process.env.REACT_APP_URL_IMAGE}/${moduleData.module_image}`
                : '/default-image.jpg';
            setModuleData({ ...moduleData, image: imagePath });
            setPreviewImage(imagePath);
        } catch (err) {
            console.error(err.response);  // Afficher l'erreur complète
            console.error(err.response?.data?.message || "Erreur lors du chargement du module");
        } finally {
            setLoading(false);
        }
    };
    // API get objectif
    const fetchObjectif = async () => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN'); // même nom que plus haut
            const responseObjectif = await axios.get(`${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/objectifs`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            const objectifsData = responseObjectif.data.objectifs;
            if (Array.isArray(objectifsData)) {
                setObjectifs(objectifsData);
            } else {
                setObjectifs([]);
            }

        } catch (err) {
            console.error(err.response); // Corrigé ici aussi
        } finally {
            setLoading(false);
        }
    };
    //API get prerequis
    const fetchPrerequis = async () => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN'); // même nom que plus haut
            const responsePrerequis = await axios.get(`${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/prerequis`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            const prerequisData = responsePrerequis.data.prerequis;
            if (Array.isArray(prerequisData)) {
                setPrerequis(prerequisData);
            } else {
                setPrerequis([]);
            }

        } catch (err) {
            console.error(err.response); // Corrigé ici aussi
        } finally {
            setLoading(false);
        }
    }
    // API get matériel(prestation)
    const fetchMateriel = async () => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const responsePrestation = await axios.get(`${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/prestations`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            // Vérifie la structure de la donnée reçue
            const prestationData = responsePrestation.data?.prestations;

            if (Array.isArray(prestationData) && prestationData.length > 0) {
                setPrestation(prestationData);
            } else {
                console.warn("Aucun matériel disponible ou données mal formées :", prestationData);
                setPrestation([]);
            }

        } catch (err) {
            console.error("Erreur dans la requête API :", err.response || err);
        } finally {
            setLoading(false);
        }
    };
    //API get cible
    const fetchCible = async () => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const responseCible = await axios.get(`${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/cibles`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });

            // Vérifie la structure de la donnée reçue
            const cibleData = responseCible.data?.cibles;

            if (Array.isArray(cibleData) && cibleData.length > 0) {
                setCible(cibleData);
            } else {
                setCible([]);
            }

        } catch (err) {
            console.error("Erreur dans la requête API :", err.response || err);
        } finally {
            setLoading(false);
        }
    }
    //API get programmes
    const fetchProgramme = async () => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/entreprise/module-programmes/${id}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json'
                    }
                }
            );
            console.log("ID du module:", id);

            console.log("Réponse API:", response.data);

            if (response.data.status === 200) {
                if (Array.isArray(response.data.programmes)) {
                    setProgrammes(response.data.programmes);
                    setError(null);
                } else {
                    toast.error("Format de données inattendu");
                    setProgrammes([]);
                }
            } else if (response.data.status === 404) {
                toast.error(response.data.message); // "Module introuvable !"
                setProgrammes([]);
            }

        } catch (err) {
            console.error("Erreur API:", err.response); // Ajout important
            console.error(err.response?.data?.message || "Erreur lors de la récupération des programmes");
            setProgrammes([]);
        }
    };
    //API get qualité
    const fetchQualityScore = async () => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/quality`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json'
                    }
                }
            );
            setQualityScore(response.data.sumQuality);
        } catch (error) {
            console.error("Erreur lors de la récupération du score qualité:", error);

        }
    };

    //API ajout objectif
    const handleAddObjectif = async () => {
        if (!newObjectif.trim()) return;
        let tempId;
        try {
            tempId = -Date.now();
            const tempObjectif = {
                idObjectif: tempId,
                objectif: newObjectif,
                idModule: id
            };
            setObjectifs(prev => [...prev, tempObjectif]);
            setNewObjectif("");
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/objectifs`,
                { name: newObjectif },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            await fetchQualityScore();
            console.log("Données reçues :", response.data);
            const realObjectif = response.data;
            if (!realObjectif || typeof realObjectif !== 'object') {
                throw new Error("Objectif mal formaté ou non reçu.");
            }

            setObjectifs(prev =>
                prev.filter(obj =>
                    obj.idObjectif === tempId ? realObjectif : obj
                )
            );
            toast.success("Objectif ajouté avec succès !");
        } catch (error) {
            setObjectifs(prev => prev.filter(obj => obj.idObjectif !== tempId));
            toast.error("Erreur lors de l'ajout");
        }
    };
    //API delete objectif
    const DeleteObjectif = async (idObjectif) => {
        if (!idObjectif) {
            console.error("Suppression appelée avec ID undefined");
            return;
        }

        // Gestion spéciale pour les IDs temporaires (négatifs)
        if (idObjectif < 0) {
            setObjectifs(prev => prev.filter(obj => obj.idObjectif !== idObjectif));
            return;
        }

        try {
            await axios.delete(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/objectifs/${idObjectif}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            await fetchQualityScore();

            setObjectifs(prev => prev.filter(obj => obj.idObjectif !== idObjectif));
            toast.success("Objectif supprimé avec succès !");
        } catch (error) {
            console.error("Échec de la suppression:", error);
            toast.error("Échec de la suppression. Veuillez réessayer.");
        }
    }
    // sans rafraichir la page pour la modification
    const handleObjectifUpdatedEtp = (updatedObjectifEtp) => {
        setObjectifs((prev) =>
            prev.map((obj) =>
                obj.idObjectif === updatedObjectifEtp.idObjectif
                    ? { ...obj, objectif: updatedObjectifEtp.objectif }
                    : obj
            )
        );
    };

    // API ajout prerequis
    const handleAddPrerequis = async () => {
        if (!newPrerequis.trim()) return;

        let tempId = -Date.now(); // ID temporaire
        const tempPrerequis = {
            idPrerequis: tempId,
            prerequis_name: newPrerequis,
            idModule: id
        };

        // Ajout optimiste
        setPrerequis(prev => [...prev, tempPrerequis]);
        setNewPrerequis("");

        try {
            const resPrerequis = await axios.post(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/prerequis`,
                { prerequis_name: newPrerequis },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            await fetchQualityScore();

            console.log("Réponse API:", resPrerequis.data);

            // Si l'API ne retourne pas l'objet créé, on rafraîchit la liste
            if (!resPrerequis.data.prerequis) {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/prerequis`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );

                setPrerequis(response.data.prerequis || []);
                toast.success("Prerequis ajouté avec succès !");
            } else {
                // Si l'API retourne l'objet créé, on met à jour
                setPrerequis(prev =>
                    prev.map(prer =>
                        prer.idPrerequis === tempId ? resPrerequis.data.prerequis : prer
                    )
                );
            }

        } catch (error) {
            console.error(`Erreur détaillé: ${error.response?.data?.message || error.message}`);
            // Annulation de l'ajout optimiste en cas d'erreur
            setPrerequis(prev => prev.filter(prer => prer.idPrerequis !== tempId));
            console.error(`Erreur lors de l'ajout de prérequis; veuillez essayer`);
        }
    }
    //API delete prerequis
    const DeletePrerequis = async (idPrerequis) => {
        if (!idPrerequis) {
            console.error("Suppression appelée avec ID undefined");
            return;
        }

        // Gestion spéciale pour les IDs temporaires (négatifs)
        if (idPrerequis < 0) {
            setPrerequis(prev => prev.filter(prer => prer.idPrerequis !== idPrerequis));
            return;
        }

        try {
            await axios.delete(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/prerequis/${idPrerequis}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            await fetchQualityScore();
            setPrerequis(prev => prev.filter(obj => obj.idPrerequis !== idPrerequis));
            toast.success("Prerequis supprimer avec succès !");
        } catch (error) {
            console.error("Échec de la suppression:", error);
            toast.error("Échec de la suppression. Veuillez réessayer.");
        }
    }

    //API ajout matériel(prestation)
    const handleAddMateriels = async () => {
        if (!newPrestation.trim()) return;

        let tempId = -Date.now(); // ID temporaire
        const tempPrestation = {
            idPrestation: tempId,
            prestation_name: newPrestation,
            idModule: id
        };

        // Ajout optimiste
        setPrestation(prev => [...prev, tempPrestation]);
        setNewPrestation("");

        try {
            const resPrestation = await axios.post(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/prestations`,
                { prestation_name: newPrestation },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            await fetchQualityScore();
            console.log("Réponse API:", resPrestation.data);

            // Si l'API ne retourne pas l'objet créé, on rafraîchit la liste

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/prestations`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            setPrestation(response.data.prestations || []);
            toast.success("Matériel ajouté avec succès !");

        } catch (error) {
            console.error(`Erreur lors de l'ajout: ${error.response?.data?.message || error.message}`);
            // Annulation de l'ajout optimiste en cas d'erreur
            setPrestation(prev => prev.filter(pres => pres.idPrestation !== tempId));
            console.error(`Erreur lors de l'ajout des matériels`);
        }
    }
    //API delete matériel(prestation)
    const DeletePrestation = async (idPrestation) => {
        if (!idPrestation) {
            console.error("Suppression appelée avec ID undefined");
            return;
        }

        // Gestion spéciale pour les IDs temporaires (négatifs)
        if (idPrestation < 0) {
            setPrestation(prev => prev.filter(prer => prer.idPrestation !== idPrestation));
            return;
        }

        try {
            await axios.delete(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/prestations/${idPrestation}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            await fetchQualityScore();
            setPrestation(prev => prev.filter(obj => obj.idPrestation !== idPrestation));
            toast.success("Matériel supprimer avec succès !");
        } catch (error) {
            toast.error("Échec de la suppression");
            console.error("Échec de la suppression. Veuillez réessayer.", error);
        }
    }

    //API ajout cible
    const handleAddCible = async () => {
        if (!newCible.trim()) return;

        let tempId = -Date.now(); // ID temporaire
        const tempCible = {
            idCible: tempId,
            cible_name: newCible,
            idModule: id
        };

        // Ajout optimiste
        setCible(prev => [...prev, tempCible]);
        setNewCible("");

        try {
            const resCible = await axios.post(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/cibles`,
                { cible_name: newCible },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            await fetchQualityScore();
            console.log("Réponse API:", resCible.data);

            // Si l'API ne retourne pas l'objet créé, on rafraîchit la liste

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/cibles`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            setCible(response.data.cibles || []);
            toast.success("Cible ajouté avec succès !");

        } catch (error) {
            console.error("Erreur détaillée:", error);
            // Annulation de l'ajout optimiste en cas d'erreur
            setCible(prev => prev.filter(cib => cib.idCible !== tempId));
            // alert(`Erreur lors de l'ajout: ${error.response?.data?.message || error.message}`);
            toast.error("Erreur lors de l\'ajout du programme");
        }
    }
    //API dete cible
    const DeleteCible = async (idCible) => {
        if (!idCible) {
            console.error("Suppression appelée avec ID undefined");
            return;
        }

        // Gestion spéciale pour les IDs temporaires (négatifs)
        if (idCible < 0) {
            setCible(prev => prev.filter(cib => cib.idCible !== idCible));
            return;
        }

        try {
            await axios.delete(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/cibles/${idCible}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            await fetchQualityScore();
            setCible(prev => prev.filter(obj => obj.idCible !== idCible));
            toast.success("Cible supprimer avec succès !");
        } catch (error) {
            console.error("Échec de la suppression:", error);
            toast.error("Échec de la suppression. Veuillez réessayer.");
        }
    }

    const handleProgrammeInputChange = (e) => {
        const { name, value } = e.target;
        setNewProgramme(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleAddProgramme = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/entreprise/module-programmes/${id}`,
                {
                    program_title: newProgramme.program_title,
                    program_description: newProgramme.program_description
                },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            await fetchProgramme();
            console.log("programmeData envoyé :", response);

            if (response.data.status === 200) {
                setNewProgramme({
                    program_title: '',
                    program_description: ''
                });

                // Fermer le formulaire si besoin
                setIsFormVisible(false);

                // Afficher un message de succès
                toast.success('Programme ajouté avec succès');
            }
        } catch (error) {
            console.error('Erreur lors de l\'ajout du programme:', error);
            toast.error('Erreur lors de l\'ajout du programme');
        } finally {
            setIsSubmitting(false);
        }
    };
    //API delete programme
    const DeleteProgramme = async (idProgramme) => {
        if (!idProgramme) {
            console.error("Suppression appelée avec ID undefined");
            return;
        }

        // Gestion spéciale pour les IDs temporaires (négatifs)
        if (idProgramme < 0) {
            setProgrammes(prev => prev.filter(prog => prog.idProgramme !== idProgramme));
            return;
        }
        try {
            await axios.delete(
                `${process.env.REACT_APP_API_URL}/entreprise/module-programmes/${id}/${idProgramme}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json'
                    }
                }
            );
            await fetchQualityScore();
            setProgrammes(prev => prev.filter(obj => obj.idProgramme !== idProgramme));
            toast.success("Programme supprimé avec succès !");
        } catch (error) {
            console.error("Échec de la suppression:", error);
            toast.error("Échec de la suppression. Veuillez réessayer.");
        }
    };
    const handleUpdateProgramme = (updatedProgramme) => {
        setProgrammes(prev => prev.map(prog =>
            prog.idProgramme === updatedProgramme.idProgramme ? updatedProgramme : prog
        ));
    };

    const handleFileChange = (e) => {
        setFile(Array.from(e.target.files)); // Tous les fichiers
        toast.error(null);
        toast.success(null);
    };

    //ajout ressource
    const handleSubmit = async () => {
        if (!file || file.length === 0) return;

        const formData = new FormData();
        file.forEach(f => formData.append('module_ressource_file[]', f));

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}/entreprise/module/ressources/${id}`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                }
            );
            await fetchQualityScore();
            // Avec axios, les données sont directement dans res.data
            if (res.data.status === 200) {
                toast.success("Fichier importé avec succès");
                fetchRessource();
                //setUploadedFiles(res.data.files); // Fichiers renvoyés par Laravel
                setIsRessource(false); // Fermer modal
                setFile([]); // Réinitialiser l'input
            } else {
                console.error('Une erreur est survenue');
            }
        } catch (err) {
            console.error('Erreur détaillée:', err.response?.data?.message);
            toast.error('Erreur lors de l\'importation');
        }
    };
    //ressource
    const fetchRessource = async () => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const responseRessource = await axios.get(`${process.env.REACT_APP_API_URL}/entreprise/module/ressources/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            await fetchQualityScore();
            console.log("donné dans le fetchRessoure:", responseRessource.data);

            const dataRessources = responseRessource.data
            if (Array.isArray(dataRessources) && dataRessources.length > 0) {
                setUploadedFiles(dataRessources);
            } else {
                setUploadedFiles([]);
            }
        } catch (err) {
            console.error("Erreur dans la requête API :", err.response || err);
            console.error(err.response?.data?.message || "Erreur lors de la récupération des fichiers");
        } finally {
            setLoading(false);
        }
    }
    //suppression de fichier importé
    const handleDeleteRessource = async (idModuleRessource) => {
        try {
            const token = localStorage.getItem("ACCESS_TOKEN");
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/entreprise/module/ressources/${idModuleRessource}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
                }

            });
            await fetchQualityScore();
            console.log("Suppression de la ressource ID:", idModuleRessource);
            if (response.data.status === 200) {
                // Mettre à jour l'état local pour supprimer le module visuellement
                setUploadedFiles(prev =>
                    prev.filter(file => file.idModuleRessource !== idModuleRessource)
                );
                toast.success("Fichier supprimé avec succès !");
            } else {
                toast.error(response.data.message || "Échec de la suppression");
            }

        } catch (error) {
            console.error("Échec de la suppression:", error.response?.data || error);
            //toast.error("Échec de la suppression. Veuillez réessayer.");
            const backendMessage = error?.response?.data?.error || error?.response?.data?.message || "Erreur inconnue";
            toast.error(`Erreur : ${backendMessage}`);
        }
    }
    // téléchargé fichier
    const handDownloadRessource = async (idModuleRessource, nomFichier) => {
        try {
            const token = localStorage.getItem("ACCESS_TOKEN");
            console.log("Début du téléchargement du fichier ID:", idModuleRessource);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/entreprise/module/ressources/${idModuleRessource}/download`, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
                }
            });
            console.log(response.headers['content-type']);

            // Créer un lien temporaire pour télécharger le fichier
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomFichier); // ou `${idModuleRessource}.pdf` par exemple
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Erreur de téléchargement :", error);
            toast.error("Échec du téléchargement du fichier.");
        }
    }

    //changement de status
    const updateStatus = async (id, action) => {
        console.log("id:", id);
        console.log("action:", action);

        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            console.log("Token utilisé :", token);
            const response = await axios.patch(`${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/${action}`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            console.log(response);

            if (response.status === 200) {
                toast.success("Mise à jour avec succès");
                // setModuleData(prev => ({
                //     ...prev,
                //     status: action
                // }));
                window.location.reload();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("une erreur est survenue");
        }

    };

    //modification image
    const handleFileChangeImage = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 2 * 1024 * 1024) {
            toast.error("L'image doit faire moins de 2MB");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64Image = reader.result;
            setImage(base64Image); // <== image = base64 string
            setPreviewImage(base64Image);
            toast.success("Image séléctionnée, veuillez validé la modification")
        };
        setSelectImage(file);
        reader.readAsDataURL(file);
    };

    const handleUpload = async () => {
        if (!image) {
            console.log("image vide:", image);
            toast.error("Veuillez sélectionner une image.");
            return;
        }
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/entreprise/modules/${id}/images`,
                { image },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: 'application/json',
                        //"Content-Type" : "multipart/form-data"
                    },
                }
            );
            // Corriger ici 👇 - reconstruire le chemin complet
            const fullImagePath = `${process.env.REACT_APP_URL_IMAGE}/${response.data.imagePath}`;
            setPreviewImage(fullImagePath);
            setModuleData(prev => ({
                ...prev,
                module_image: response.data.imagePath,
                image: fullImagePath

            }));
            //alert("donnée:",response.data);
            toast.success("Image modifiée avec succès !");
        } catch (error) {
            console.error("test", error);
            console.error("Une erreur est survenue.");
        }
    };

    const fromStatus = location.state?.fromStatus; // online / offline / trash
    const statusColors = {
        online: 'bg-green-500 text-white',   // couleur spéciale si on vient de "Disponible"
        offline: 'bg-orange-500 text-white',  // couleur spéciale si on vient de "Préparation"
        trash: 'bg-red-500 text-white'     // couleur spéciale si on vient de "Corbeille"
    };


    //page loading, gestion d'erreur
    if (loading) return <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-50 flex items-center justify-center px-4">
        <div className="text-center ">
            <p className="text-gray-700 text-xl font-semibold ">veuillez patienter...</p>
            <div className="flex justify-center space-x-2">
                <div className="w-3 h-3  animate-bounce">📚</div>
                <div className="w-3 h-3  animate-bounce [animation-delay:-0.2s]">📚</div>
                <div className="w-3 h-3  animate-bounce [animation-delay:-0.4s]">📚</div>
            </div>
        </div>

    </div>
    if (error) return <div>{error}</div>;
    if (!moduleData) return <div>Module non trouvé</div>;

    console.log(moduleData)

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="flex flex-col w-full mt-8 sm:mt-24">

                <div className="container flex flex-col  gap-4 mx-auto">

                    {/* Qualité - Responsive */}
                    <div className="flex flex-col sm:flex-row items-start gap-4 p-4 bg-white rounded-lg shadow-md ">
                        <button
                            onClick={() => navigate(-1)}
                            className="text-gray-500 text-xl shrink-0 flex items-center"
                        >
                            <icons.back />
                        </button>

                        <div className="flex flex-col sm:flex-row w-full gap-4 items-start sm:items-center">

                            {/* Bloc Quality */}
                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 flex-1">
                                <p className="text-gray-700 font-medium whitespace-nowrap">Quality</p>
                                <div className="relative w-full sm:w-64 bg-gray-400 rounded-lg h-5 overflow-hidden">
                                    <div
                                        className={`h-full rounded-lg transition-all duration-300 ${clampeQualityPercentage < 30
                                            ? 'bg-red-600'
                                            : clampeQualityPercentage < 70
                                                ? 'bg-yellow-500'
                                                : 'bg-green-500'
                                            }`}
                                        style={{ width: `${clampeQualityPercentage}%` }}
                                    ></div>
                                    <span className="absolute right-2 top-1/2 -translate-y-1/2 text-white text-sm font-semibold">
                                        {clampeQualityPercentage}%
                                    </span>
                                </div>
                            </div>

                            {/* Bloc des boutons de statut */}
                            <div className="flex flex-wrap gap-2 bg-gray-200 rounded-full p-1">

                                {['online', 'offline', 'trash'].map((status) => {
                                    const isFromPage = fromStatus === status;

                                    return (
                                        <button
                                            key={status}
                                            className={`px-3 py-1 rounded-full font-medium text-sm transition 
                ${isFromPage
                                                    ? statusColors[status]
                                                    : moduleData?.status === status
                                                        ? status === 'online'
                                                            ? 'bg-green-500 text-white'
                                                            : status === 'offline'
                                                                ? 'bg-yellow-500 text-white'
                                                                : 'bg-red-500 text-white'
                                                        : 'bg-gray-100 hover:bg-gray-300'
                                                }`}
                                            onClick={() => updateStatus(id, status, status)}
                                        >
                                            {status === 'online'
                                                ? 'Disponible'
                                                : status === 'offline'
                                                    ? 'En Préparation'
                                                    : 'Corbeille'}
                                        </button>
                                    );
                                })}

                            </div>
                        </div>

                    </div>

                    {/* Nom et référence - Responsive */}
                    <div className="w-full flex flex-col sm:flex-row justify-between gap-2 p-2 bg-[#5B345B] text-white">
                        <div className="text-sm sm:text-base font-medium flex items-center gap-2">

                            <p>{moduleData.module_domain_name}</p>
                        </div>
                        <div className="text-sm sm:text-base flex items-center justify-start sm:justify-end">
                            <p>Ref. {moduleData.module_reference}</p>
                        </div>
                    </div>

                    {/* Image et contenu - Responsive */}
                    <div className="flex flex-col md:flex-row gap-4 bg-white p-4 rounded-lg">
                        {/* Section Image */}

                        <div>
                            <div >
                                <img
                                    src={previewImage}
                                    className="w-48 h-20 object-cover rounded-lg"
                                    alt="Image"
                                />
                            </div>
                            <div className="card-body">
                                <div className="flex flex-col sm:flex-row items-center gap-4 w-max bg-white border border-gray-300 rounded-lg px-2 py-2 mt-2 shadow-sm ">

                                    {/* Icône + texte (label) */}
                                    <label
                                        htmlFor="image-upload"
                                        className="cursor-pointer flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-md transition w-full sm:w-auto"
                                    >
                                        <input
                                            id="image-upload"
                                            type="file"
                                            accept="image/*"
                                            onChange={handleFileChangeImage}
                                            className="hidden"
                                        />
                                        <icons.pen className="text-purple-700 w-5 h-5" />
                                        <span className="text-sm text-gray-700 truncate max-w-[160px]">
                                            {selectImage ? selectImage.name : "Choisir "}
                                        </span>
                                    </label>

                                    {/* Bouton Modifier */}
                                    <button
                                        onClick={handleUpload}
                                        className="text-sm font-medium text-white bg-purple-700 hover:bg-purple-800 active:bg-purple-900 px-4 py-2 rounded-md transition w-full sm:w-auto"
                                        disabled={!selectImage} // Empêche de cliquer si pas d'image
                                    >
                                        Valider
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Section Texte */}
                        <div className="w-full md:w-2/3">
                            <h1 className="text-xl font-bold">{moduleData.module_name}</h1>
                            <p className="italic text-sm mt-2 text-gray-600">{moduleData.module_subtitle}</p>
                            <p className="text-sm mt-3 text-gray-700">{moduleData.module_description}</p>
                        </div>
                    </div>

                    {/* Contenu principal - Responsive */}
                    <div className="flex flex-col lg:flex-row gap-4 w-full">
                        {/* Colonne gauche */}
                        <div className="w-full lg:w-1/3 flex flex-col gap-4">
                            {/* Formation de base */}

                            <div className="w-full p-3 bg-slate-100 rounded-xl shadow-sm">
                                <span className="mb-3">
                                    <input type="checkbox" id="drawer-toggle-edit-cours" className="relative hidden sr-only peer" />
                                    <div className="flex items-center justify-center duration-150 rounded-full w-max">
                                        <button
                                            className="flex items-center gap-1 text-[12px] font-medium  text-center text-purple-500 px-5 py-2 underline" onClick={() => setIsFormationBase(true)}
                                        >
                                            <icons.pen className="text-purple-500" />
                                            Modifier les formation de base
                                        </button>
                                    </div>
                                    <ModalFormationEtp
                                        showFormation={isFormationBase}
                                        closeFormation={() => setIsFormationBase(false)}
                                        id={module.id}
                                        moduleData={moduleData}
                                        onUpdate={fetchModuleData}
                                    />
                                </span>

                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <icons.clock className="text-base text-gray-700" />
                                            </td>
                                            <td className="text-[12px] text-gray-700">
                                                {moduleData.dureeJ}jours ({moduleData.dureeH}h )
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <icons.users className="text-base text-gray-700" />
                                            </td>
                                            <td className="text-[12px] text-gray-700">
                                                {moduleData.minApprenant} à {moduleData.maxApprenant} apprenants
                                            </td>

                                        </tr>
                                        <tr>
                                            <td>
                                                <icons.medal className="text-base text-gray-700" />
                                            </td>
                                            <td className="text-[12px] text-gray-700">
                                                {moduleData.module_level_name}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <icons.info className="text-lg text-blue-500 cursor-pointer" />
                                            </td>
                                            <td className="text-[12px] text-gray-700">
                                                {parseInt(moduleData.module_price)}Ar
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <p className="text-[12px] text-gray-400">Prix de formation pour une personne.</p>
                            </div>

                            {/* Section prerequis, matériels, public */}
                            <div className="w-full p-3 gap-2 rounded-xl bg-[#5B345B]">

                                {/* Bloc Prérequis */}
                                <div className="flex flex-col gap-2 mb-6">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2 text-white">
                                            <icons.bookOpen className="text-lg" />
                                            <h5 className="text-base font-semibold">Prérequis</h5>
                                        </div>
                                        <div
                                            className="flex items-center justify-center w-8 h-8 bg-purple-200 rounded-md cursor-pointer "
                                        >
                                            <icons.pen className="text-[#9B599B] text-sm" onClick={() => setIsPrerequis(!isPrerequis)} />
                                        </div>
                                    </div>
                                    <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isPrerequis ? "max-h-40 opacity-100 py-3" : "max-h-0 opacity-0"}`}>
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-400 text-sm text-gray-700"
                                                placeholder="Ajouter un prerequis"
                                                value={newPrerequis}
                                                onChange={(e) => setNewPrerequis(e.target.value)}
                                            />
                                            <icons.plus
                                                className="bg-fuchsia-500 hover:bg-fuchsia-600 text-white p-2 rounded-md text-[24px] cursor-pointer"
                                                onClick={handleAddPrerequis}
                                            />
                                        </div>
                                    </div>
                                    <ul className="flex flex-col gap-2 ">
                                        {prerequis.map((prerequi) => (
                                            <li
                                                key={prerequi.idPrerequis}
                                                className="flex items-center justify-between bg-slate-200 px-3 py-2 rounded-md text-sm text-gray-800"
                                            >
                                                <span>{prerequi.prerequis_name}</span>
                                                <button
                                                    onClick={() => DeletePrerequis(prerequi.idPrerequis)}
                                                    className="text-red-500 hover:text-red-700 transition"
                                                >
                                                    <icons.cross className="text-red-500 hover:text-red-700 cursor-pointer" />
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Bloc Matériels */}
                                <div className="flex flex-col gap-2 mb-6">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2 text-white">
                                            <icons.boxOpen className="text-lg" />
                                            <h5 className="text-base font-semibold">Matériels utiles à la formation</h5>
                                        </div>
                                        <div
                                            className="flex items-center justify-center w-8 h-8 bg-purple-200 rounded-md cursor-pointer "
                                        >
                                            <icons.pen className="text-[#9B599B] text-sm" onClick={() => setIsMateriel(!isMateriel)} />
                                        </div>
                                    </div>
                                    <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isMateriel ? "max-h-40 opacity-100 py-3" : "max-h-0 opacity-0"}`}>
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-400 text-sm text-gray-700"
                                                placeholder="Ajouter un ou des matériel(s)"
                                                value={newPrestation}
                                                onChange={(e) => setNewPrestation(e.target.value)}
                                            />
                                            <icons.plus
                                                className="bg-fuchsia-500 hover:bg-fuchsia-600 text-white p-2 rounded-md text-[24px] cursor-pointer"
                                                onClick={handleAddMateriels}
                                            />
                                        </div>
                                    </div>
                                    <ul className="flex flex-col gap-2 ">
                                        {prestation.map((p) => (
                                            <li key={p.idPrestation} className="flex items-center justify-between bg-slate-200 px-3 py-2 rounded-md text-sm text-gray-800">
                                                {p.prestation_name}
                                                <button
                                                    onClick={() => DeletePrestation(p.idPrestation)}
                                                    className="text-red-500 hover:text-red-700 transition"
                                                >
                                                    <icons.cross className="text-red-500 hover:text-red-700 cursor-pointer" />
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Bloc Public concerné */}
                                <div className="flex flex-col gap-2">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2 text-white">
                                            <icons.users className="text-lg" />
                                            <h5 className="text-base font-semibold">Public concerné</h5>
                                        </div>
                                        <div
                                            className="flex items-center justify-center w-8 h-8 bg-purple-200 rounded-md cursor-pointer "
                                        >
                                            <icons.pen className="text-[#9B599B] text-sm" onClick={() => setIsPublic(!isPublic)} />
                                        </div>
                                    </div>
                                    <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isPublic ? "max-h-40 opacity-100 py-3" : "max-h-0 opacity-0"}`}>
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-400 text-sm text-gray-700"
                                                placeholder="Ajouter un ou des concerné(e)(s)"
                                                value={newCible}
                                                onChange={(e) => setNewCible(e.target.value)}
                                            />
                                            <icons.plus
                                                className="bg-fuchsia-500 hover:bg-fuchsia-600 text-white p-2 rounded-md text-[24px] cursor-pointer"
                                                onClick={handleAddCible}
                                            />
                                        </div>
                                    </div>
                                    <ul className="flex flex-col gap-2">
                                        {cible.map((c) => (
                                            <li key={c.idCible} className="flex items-center justify-between bg-slate-200 px-3 py-2 rounded-md text-sm text-gray-800">
                                                {c.cible}
                                                <button
                                                    onClick={() => DeleteCible(c.idCible)}
                                                    className="text-red-500 hover:text-red-700 transition"
                                                >
                                                    <icons.cross className="text-red-500 hover:text-red-700 cursor-pointer" />
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                            </div>

                        </div>

                        {/* Colonne droite */}
                        <div className="w-full lg:w-2/3 flex flex-col gap-4">
                            {/* Objectifs */}
                            <div className="w-full p-3 bg-white rounded-lg">
                                <div className="flex flex-col gap-2">
                                    <div className="inline-flex items-center justify-between">
                                        <div className="inline-flex items-center text-[#9B599B] gap-2">
                                            <icons.bullseye />
                                            <h5 className="text-xl font-semibold">Objectifs</h5>
                                        </div>
                                        <div
                                            className="flex items-center justify-center w-8 h-8 duration-300 bg-purple-100 hover:bg-purple-300 rounded-md cursor-pointer  transition"
                                        >
                                            <icons.pen className="text-gray-600" onClick={() => setIsObjectif(!isObjectif)} />
                                        </div>
                                    </div>

                                    {/* Ajout d'objectif */}
                                    <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isObjectif ? "max-h-40 opacity-100 py-3" : "max-h-0 opacity-0"}`}>
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-400 text-sm text-gray-700"
                                                placeholder="Ajouter un objectif"
                                                value={newObjectif}
                                                onChange={(e) => setNewObjectif(e.target.value)}
                                            />
                                            <icons.plus
                                                className="text-white bg-fuchsia-500 hover:bg-fuchsia-600 p-2 rounded-md text-[24px] cursor-pointer"
                                                onClick={handleAddObjectif}
                                            />
                                        </div>
                                    </div>

                                    {/* Liste des objectifs */}
                                    <ul className="flex flex-col gap-2 mt-2 w-full">
                                        {objectifs.map((objectif) => (
                                            <li
                                                key={objectif.idObjectif}
                                                className="flex items-center justify-between bg-slate-100 px-3 py-2 rounded-md text-sm text-gray-800"
                                            >
                                                <span>{objectif.objectif}</span>
                                                <button
                                                    onClick={() => DeleteObjectif(objectif.idObjectif)}
                                                    className="text-red-500 hover:text-red-700 transition"
                                                >
                                                    <icons.cross />
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            {/* Programme pédagogique */}
                            <div className="w-full p-3 bg-slate-200 rounded-xl">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="flex items-center gap-3 text-gray-700">
                                        <icons.laptop className="text-xl" />
                                        <h5 className="text-lg font-semibold">Programme pédagogique</h5>
                                    </div>
                                    <button
                                        onClick={() => setIsFormVisible(!isFormVisible)}
                                        className="flex items-center justify-center w-8 h-8 bg-purple-300 rounded-md transition duration-300"
                                    >
                                        <icons.plus className="text-purple-700 text-sm" />
                                    </button>
                                </div>

                                {/* Formulaire d'ajout */}
                                <div className={`overflow-hidden transition-all duration-500 ${isFormVisible ? "max-h-[500px] opacity-100 py-4" : "max-h-0 opacity-0"}`}>
                                    <form className="space-y-4 ml-6" onSubmit={handleAddProgramme}>
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-600">Titre du programme</label>
                                            <input
                                                type="text"
                                                name="program_title"
                                                value={newProgramme.program_title}
                                                onChange={handleProgrammeInputChange}
                                                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-400 focus:outline-none"
                                                placeholder="Ex: Introduction à React"
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-600">Description du programme</label>
                                            <div className="rounded-lg border border-gray-300 overflow-hidden">
                                                <div className="flex items-center justify-between px-3 py-2 bg-gray-100 border-b">
                                                    <span className="text-sm font-medium text-gray-700">Normal</span>
                                                    <div className="flex gap-2 text-sm text-gray-600">
                                                        <button type="button" className="font-bold hover:text-black">B</button>
                                                        <button type="button" className="italic hover:text-black">I</button>
                                                        <button type="button" className="underline hover:text-black">U</button>
                                                        <button type="button" className="hover:text-black">🔗</button>
                                                        <button type="button" className="hover:text-black">•</button>
                                                        <button type="button" className="hover:text-black">𝒙</button>
                                                    </div>
                                                </div>
                                                <textarea
                                                    name="program_description"
                                                    value={newProgramme.program_description}
                                                    onChange={handleProgrammeInputChange}
                                                    className="w-full px-3 py-2 bg-white text-gray-700 resize-none focus:outline-none"
                                                    rows="4"
                                                    placeholder="Décrivez le contenu du programme..."
                                                    required
                                                />

                                            </div>
                                        </div>

                                        <button
                                            type="submit"
                                            className="px-4 py-2 bg-purple-700 text-white rounded-md hover:bg-purple-800 text-sm"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'En cours...' : 'Ajouter'}
                                        </button>
                                    </form>
                                </div>

                                {/* Liste des modules */}
                                <div className="mt-6 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {programmes.length > 0 ? (
                                        programmes.map((programme, index) => (
                                            <div key={programme.idProgramme} className="bg-white rounded-lg shadow p-4">
                                                <div className="flex justify-between items-center">
                                                    <div className="flex items-center justify-center gap-4">
                                                        <h1 className="font-bold text-gray-700">Module{index + 1}</h1>
                                                        <div className="flex gap-2">
                                                            <button
                                                                className="text-[#5B345B] text-sm "
                                                                onClick={() => {
                                                                    setSelectedProgramme({
                                                                        ...programme,
                                                                        moduleId: id// Ajoutez l'ID du module courant
                                                                    });
                                                                    setIsModifProgramme(true)
                                                                }}
                                                            >
                                                                <icons.pen />
                                                            </button>

                                                            <button
                                                                className=" text-sm text-red-500"
                                                                onClick={() => DeleteProgramme(programme.idProgramme)}
                                                            >
                                                                <icons.trashAlt />
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>

                                                <h2 className="font-bold text-purple-900 ">
                                                    {programme.program_title}
                                                </h2>
                                                <div
                                                    className="text-gray-800"
                                                    dangerouslySetInnerHTML={{ __html: programme.program_description }}
                                                />

                                            </div>
                                        ))
                                    ) : (
                                        <div className="col-span-full text-center py-4 text-gray-500">
                                            Aucun programme disponible pour ce module
                                        </div>
                                    )}
                                </div>
                                {selectedProgramme && (
                                    <ModalProgrammeEtp
                                        showProgramme={isModifProgramme}
                                        closeProgramme={() => setIsModifProgramme(false)}
                                        programme={selectedProgramme}
                                        id={id}
                                        idProgramme={selectedProgramme.idProgramme}
                                        onUpdate={handleUpdateProgramme}
                                    />
                                )}
                            </div>

                            {/* Ressources */}
                            <div className="w-full p-3 bg-slate-100 rounded-xl group/right2  gap-3 mt-3">
                                <div className="inline-flex items-center gap-4">
                                    <div className="flex items-center gap-2 text-gray-500">
                                        <icons.bookmark />
                                        <h5 className="text-[12px] font-semibold">Vos ressources</h5>
                                    </div>
                                    <button
                                        type="button"
                                        className="inline-flex items-center justify-center gap-2 text-gray-500 duration-200 bg-transparent text-md hover:text-gray-700"
                                        data-bs-toggle="modal" data-bs-target="#supportLg"
                                        onClick={() => setIsRessource(true)}
                                    >
                                        <icons.upload />
                                        Importer vos ressources
                                    </button>
                                    <div className="modal fade support" id="supportLg" data-bs-backdrop="static"
                                        data-bs-keyboard="false" tabindex="-1">
                                    </div>
                                </div>

                                {/* Affichage fichier importer */}
                                <div className="w-full mt-6 overflow-x-auto">
                                    <div className="inline-block min-w-full shadow-md rounded-lg overflow-hidden">
                                        <table className="min-w-full leading-normal">
                                            <thead>
                                                <tr className="bg-[#5B345B] text-white text-left">
                                                    <th className="px-6 py-3 text-sm font-semibold">Nom</th>
                                                    <th className="px-6 py-3 text-sm font-semibold">Type</th>
                                                    <th className="px-6 py-3 text-sm font-semibold">Taille</th>
                                                    <th className="px-2 py-3 text-sm font-semibold">Actions</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {uploadedFiles.map((fichier, index) => (
                                                    console.log("FICHIER", fichier),
                                                    <tr key={index} className="bg-white border-b hover:bg-gray-50 transition">
                                                        <td className="px-6 py-4 text-gray-800">{fichier.module_ressource_name}</td>
                                                        <td className="px-6 py-4 text-gray-800">{fichier.module_ressource_extension}</td>
                                                        <td className="px-6 py-4 text-gray-800">{fichier.taille} Mo</td>
                                                        <td className="px-2">
                                                            <div className="flex gap-6">
                                                                <button
                                                                    onClick={() => handDownloadRessource(fichier.idModuleRessource, fichier.module_ressource_name)}
                                                                    className="flex items-center text-blue-600 hover:underline"
                                                                >
                                                                    <icons.download className="mr-1" />
                                                                </button>
                                                                <button
                                                                    className="flex items-center text-red-600 hover:text-red-800"
                                                                    onClick={() => handleDeleteRessource(fichier.idModuleRessource)}
                                                                >
                                                                    <icons.trash2 className="mr-1" />
                                                                </button>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>

                                <p className="text-xs text-gray-500 text-center">Taille maximale autorisée : 10MB</p>

                            </div>


                            {/* Modal importé des fichier */}
                            {isRessource && (
                                <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-50 flex items-center justify-center">
                                    <div className="bg-white shadow-2xl rounded-2xl w-11/12 md:w-3/4 lg:w-1/2 max-h-[90vh] overflow-hidden" data-aos="fade-down" data-aos-delay="300">
                                        {/* Header */}
                                        <div className="flex items-center justify-between px-5 py-3 bg-[#5B345B] border-b">
                                            <p className="text-lg font-bold text-white text-center">Veuillez Selectionner votre Fichier à importer</p>
                                        </div>
                                        {/* Body */}
                                        <div className="p-6 space-y-4 flex flex-col items-center text-center">
                                            {/* Icône dynamique */}
                                            <HiOutlineDocument
                                                className={`w-16 h-16 ${file ? "text-[#5B345B]" : "text-gray-400"
                                                    } transition duration-300`}
                                            />

                                            {/* Input */}
                                            <input
                                                type="file"
                                                multiple
                                                onChange={handleFileChange}
                                                className="block w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#5B345B] file:text-white hover:file:bg-[#472947]"
                                            />

                                            {/* Texte état */}
                                            <p className="text-sm text-gray-700">
                                                {file && file.length > 0
                                                    ? `Fichier(s) sélectionné(s) : ${file.map(f => f.name).join(', ')}`
                                                    : "Aucun fichier sélectionné"}
                                            </p>


                                            <p className="text-xs text-gray-500">Taille de fichier maximum : 10MB</p>
                                        </div>

                                        {/* Footer */}
                                        <div className="flex justify-end gap-3 px-6 py-4 border-t">
                                            <button
                                                onClick={() => setIsRessource(false)}
                                                className="px-4 py-2 rounded-md bg-gray-300 text-gray-800 hover:bg-gray-400 transition"
                                            >
                                                Annuler
                                            </button>
                                            <button
                                                className="px-4 py-2 rounded-md bg-[#5B345B] text-white hover:bg-[#472947] transition disabled:opacity-50 disabled:cursor-not-allowed"
                                                onClick={handleSubmit}
                                            >
                                                Importer
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>

            </div>
        </>

    );
}